module.exports = __webpack_public_path__ + "static/media/gw13.f00fb3ee.webp";